angular.module('unica_archive_media.archive_media_services')

.factory('ArchiveMediaListService', function ($http, getBaseApiURL) {

	var mediaListService = {};

	mediaListService.list = function (eventId, directoryId, limit, offset) {
		return $http({
			method: 'POST',
			url: getBaseApiURL + '/media/list-archive/' + eventId + '/' + directoryId,
			data: {
				limit: limit,
				offset: offset,
			}
		}).then(function(result) {

			if ( result ) {
				return result.data.medias;
			}

		});

	};


	mediaListService.get = function (mediaId)
	{
		return $http({
			method: 'POST',
			url: getBaseApiURL + '/media/detail/' + mediaId,
			data: {}
		}).then(function(result) {

			if ( result ) {
				return result.data.media;
			}

		});
	};


	mediaListService.getPresignedUrlPUT = function (eventId, fileAWS)
	{
		
		return $http({
			method: 'POST',
			url: getBaseApiURL + '/media/preupload-archive/' + eventId,
			data: {
				name: fileAWS.name,
				type: fileAWS.type
			}
		}).then(function(result) {

			if ( result ) {
				return result.data.info;
			}

		});

	};

	mediaListService.getPresignedUrlGET = function (id)
	{
		
		return $http({
			method: 'GET',
			url: getBaseApiURL + '/media/url-archive/' + id,
		}).then(function(result) {

		});

	};


	mediaListService.download = function (id)
	{
		window.open(getBaseApiURL + '/media/download-archive/' + id);
		/*return $http({
			method: 'GET',
			url: getBaseApiURL + '/media/download-archive/' + id,
		}).then(function(result) {

		});*/

	};

	mediaListService.saveArchive = function (eventId, directoryId, fileAWS)
	{
		return $http({
			method: 'POST',
			url: getBaseApiURL + '/media/save-archive',
			data: {
				eventId: eventId,
				directoryId: directoryId,
				awsName: fileAWS.awsName,
				name: fileAWS.name,
				type: fileAWS.type,
				thumb: fileAWS.thumb,
			}
		}).then(function(result) {

			if ( result ) {
				return result.data.url;
			}

		});

	};

	return mediaListService;
});